module.exports = __webpack_public_path__ + "static/media/mining.eb3e4848.svg";